import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterLink, RouterLinkActive } from '@angular/router'

import { MenuItem, MenuSection } from '../../../interfaces/menu.interface'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'

@Component({
  selector: 'case-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, HasPermissionDirective]
})
export class SideMenuComponent implements OnInit, OnChanges {
  @Input() menuItems: MenuItem[]
  @Input() menuSections: MenuSection[]
  @Input() path: string
  @Input() isCollapsed = false

  activeAccordion: string

  ngOnInit(): void {
    this.expandActiveAccordion()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['path'] && !changes['path'].firstChange) {
      this.expandActiveAccordion()
    }
  }

  private expandActiveAccordion(): void {
    if (!this.path) return

    // Check menuSections for matching submenu items
    if (this.menuSections) {
      for (let sectionIndex = 0; sectionIndex < this.menuSections.length; sectionIndex++) {
        const section = this.menuSections[sectionIndex]
        for (let itemIndex = 0; itemIndex < section.items.length; itemIndex++) {
          const menuItem = section.items[itemIndex]
          if (menuItem.items?.some(subItem => this.path.startsWith(subItem.routePath))) {
            this.activeAccordion = `accordion-${sectionIndex}-${itemIndex}`
            return
          }
        }
      }
    }

    // Check legacy flat menuItems for matching submenu items
    if (this.menuItems) {
      for (let i = 0; i < this.menuItems.length; i++) {
        const menuItem = this.menuItems[i]
        if (menuItem.items?.some(subItem => this.path.startsWith(subItem.routePath))) {
          this.activeAccordion = `accordion-${i}`
          return
        }
      }
    }
  }

  toggleAccordion(accordion: string): void {
    if (this.activeAccordion === accordion) {
      this.activeAccordion = null
    } else {
      this.activeAccordion = accordion
    }
  }

  hideCollapsedAccordion() {
    if (this.isCollapsed) {
      delete this.activeAccordion
    }
  }

  showCollapsedAccordion(accordion: string): void {
    if (this.isCollapsed) {
      this.activeAccordion = accordion
    }
  }
}
